import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { addSnackbar } from 'theSource/components';
import { api } from 'theSource/utils';
import { GET_COMPANY_QUERY_KEY } from './utils';
import { MyCompanyCategory, MyCompanyCategoriesResponseDto } from './types';

export interface UseCompanyQueryResult {
  myCompanyCategoriesData: MyCompanyCategory[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
}

export const useMyCompanyQuery = (): UseCompanyQueryResult => {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const fetchCompanyCategories = () =>
    api
      .get<MyCompanyCategoriesResponseDto>(`/pwa/my_company_categories`)
      .then((response) => response.data);

  const {
    data: myCompanyCategoriesData,
    isLoading,
    isFetching,
  } = useQuery(GET_COMPANY_QUERY_KEY, fetchCompanyCategories, {
    onError: () =>
      dispatch(
        addSnackbar({
          message: t('serverError')!,
          severity: 'error',
          disableAutoHide: true,
        })
      ),
  });

  // const myCompanyCategories = feedMessagesData?.flatMap((page) => page);

  return {
    myCompanyCategoriesData,
    isLoading,
    isFetching,
  };
};
